// src/components/Analytics.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { pageview } from '../../../utils/googleAnalytics';

export default function Analytics() {
  const location = useLocation();

  useEffect(() => {
    // only send pageview if gtag exists and GA_ID set (loadGtag created it)
    pageview(location.pathname + location.search);
  }, [location]);

  return null;
}
